import { render, staticRenderFns } from "./EditOrderBatch.vue?vue&type=template&id=4ed5dbe8&scoped=true&lang=pug&"
import script from "./EditOrderBatch.vue?vue&type=script&lang=ts&"
export * from "./EditOrderBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed5dbe8",
  null
  
)

export default component.exports